.rdo-loader{background-color:#fff9;position:absolute;height:100%;inset:0;z-index:100}
/*# sourceMappingURL=loader.component-6OUNP5SP.css.map */
